<template>
  <div class="scpm-popover" v-click-outside="handleOutsideClick">
    <div class="scpm-popover__target" ref="target">
      <slot name="target"></slot>
    </div>

    <div v-if="open" class="scpm-popover__main" :style="objectStyle">
      <slot/>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, onMounted, defineEmits } from 'vue';

//emits
const emits = defineEmits(['close']);

//props
const props = defineProps({
  center: { type: Boolean },
  left: { type: [String, Number] },
  right: { type: [String, Number] },
  top: { type: [String, Number] },
  width: { type: [String, Number] },
  height: { type: [String, Number] },
  customStyle: {
    type: Object,
    default: () => ({})
  },
  open: {
    type: Boolean,
    default: () => false
  }
});

// data
const isOpen = ref(false);
const target = ref(null);
const targetWidth = ref(0);

// function

const handleOutsideClick = () => {
  emits('close');
};

onMounted(() => {
  if (target.value) {
    targetWidth.value = target.value.clientWidth;
  }
});

const objectStyle = computed(() => {
  const width = props.width ? `${props.width}px` : 'max-content';
  const height = props.height ? `${props.height}px` : 'max-content';
  const center = props.center ? `-${props.width / 2 - targetWidth.value / 2}px` : '';
  const left = props.left ? `${props.left}px` : center;
  const right = props.right && `${props.right}px`;
  const top = props.top && `${props.top}px`;

  return {
    width,
    height,
    left,
    right,
    top,
    ...props.customStyle
  };
});
</script>

<script>
export default {
  name: 'scpm-popover'
};
</script>

<style scoped lang="scss">
.scpm-popover {
  position: relative;
  display: inline-block;
  &__target {
    display: inline-block;
    z-index: 101;
  }
  &__main {
    position: absolute;
    top: 100%;
    border: 1px solid #2c5ad8;
    border-radius: 4px;
    background-color: #ffffff;
    z-index: 101;
  }
  .overlay {
    position: fixed;
    background: transparent;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100;
  }
}
</style>
